%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: 17c14f584f7d29740952e55a51d6a1fe, type: 3}
  m_Name: BossGolem
  m_EditorClassIdentifier: 
  unitModel: {fileID: 3241138547371686306, guid: 4026d9046df077946a339599f89d13a7,
    type: 3}
  heroClass: 21
  isHealer: 0
  isInternal: 1
  isBoss: 1
  level: 0
  attackSpeed: 1
  baseHP: 6500
  baseGCDMultiplier: 100
  unitName: Cryonox
  unitSpec: Ice
  icon: {fileID: 2800000, guid: 51ab4dd7eb43254459606fb4c68bdd46, type: 3}
  backgroundColor: {r: 0.8588235, g: 0.8588235, b: 0.854902, a: 1}
  textColor: {r: 0.4, g: 0.4, b: 0.4, a: 1}
  typeIcon: {fileID: 21300000, guid: 423717ccb76a74e489e5d288c5af5780, type: 3}
  type: HEALER
  description: 
  hitboxScale: {x: 4, y: 4, z: 4}
  selectionCircleScale: {x: 6, y: 2, z: 6}
  mouseHitboxScale: {x: 14, y: 3, z: 14}
  hitAnimationType: 11
  dieAnimationType: 10
  animationSpeedMultiplier: 1
  supportsStopWalkAnimation: 0
  isLeftHandClosed: 0
  isRightHandClosed: 0
  dualWields: 0
  runAnimation: {fileID: 1827226128182048838, guid: 2fb51310bb5d9174c80ddab0062351f2,
    type: 3}
  sprintAnimation: {fileID: 1827226128182048838, guid: 2fb51310bb5d9174c80ddab0062351f2,
    type: 3}
  idleAnimation: {fileID: 1125262853868821404, guid: fc1dd3c29d42f9340964b0ec777af477,
    type: 3}
  stopWalkAnimation: {fileID: 0}
  footstepSounds:
  - {fileID: 8300000, guid: f190e98ea68485c46a8b523530bfbe1a, type: 3}
  - {fileID: 8300000, guid: edc457158e6277e4492955283a098fe3, type: 3}
  - {fileID: 8300000, guid: 54ff19bbbf6d1c94b9b8c02e457dca49, type: 3}
  - {fileID: 8300000, guid: 3066b90b87bfdf14597f3cde5adfe2e0, type: 3}
  - {fileID: 8300000, guid: c9b361aab0858a7469beda7ddf39810d, type: 3}
  passiveIcon: {fileID: 21300000, guid: d3857588363cc674ea1157723c39247f, type: 3}
  passiveName: 
  passiveDescription: 
